import { gql, useMutation } from '@apollo/client';

const IMPORT_EMPLOYEES = gql`
  mutation importEmployees($csv: String!) {
    importEmployees(csv: $csv) {
      imported
      skipped
      errors
    }
  }
`;

export interface ImportResult {
  imported: number;
  skipped: number;
  errors: string[];
}

export interface ImportEmployeesResult {
  importEmployees: ImportResult;
}

export interface ImportEmployeesInput {
  csv: string;
}

export function useEmployeeImportMutation() {
  return useMutation<ImportEmployeesResult, ImportEmployeesInput>(IMPORT_EMPLOYEES, {
    refetchQueries: ['GetCompany'],
  });
}
